import { netsparkAxios } from 'core/services/HTTPService';
import { IRequestPaging } from 'core/services/HTTPService.models';
import { IEngagementsListItem } from 'pages/WirelineEngagements/WirelineEngagements.models';
import getEngagementsListUrl from 'pages/WirelineEngagements/WirelineEngagementsMainPage/WirelineEngagementsList/GetEngagementsList/apiUrls';

const getEngagementsLis = (signal, params) => netsparkAxios
  .get<IRequestPaging<IEngagementsListItem[]>>(getEngagementsListUrl, { signal, params });

export default getEngagementsLis;
